import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { FetchSearchResult } from "./SearchApi";
import { SearchReasultState } from "../../../features/view/public/searchResults/searchResultTypes";

const initialState: SearchReasultState = {
  searchData: {
    data: [],
    loader: false,
  },
};

// export const SearchAsync = createAsyncThunk(
//   "search/fetchSearchResult",
//   async (payload: any) => {
//     const response = await FetchSearchResult(payload);
//     return response;
//   }
// );
export const SearchAsync = createAsyncThunk(
  "search/fetchSearchResult",
  async ({
    category_code,
    anonymous_id,
    tag_ids,
    dynamic_filter_ids,
  }: {
    category_code: string;
    anonymous_id: string | null;
    tag_ids?: number[];
    dynamic_filter_ids?: number[];
  }) => {
    const response = await FetchSearchResult({
      category_code,
      anonymous_id,
      tag_ids,
      dynamic_filter_ids,
    });

    return response;
  }
);

export const SearchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SearchAsync.pending, (state) => {
        state.searchData.loader = true;
      })
      .addCase(SearchAsync.fulfilled, (state, action: any) => {
        state.searchData.loader = false;
        state.searchData.data = action?.payload?.data?.data || [];
      })
      .addCase(SearchAsync.rejected, (state) => {
        state.searchData.loader = false;
      });
  },
});

export default SearchSlice.reducer;
